import React, { type FunctionComponent } from 'react'
import { DateIcon, ChevronDownIcon } from '@instacart/ids-core'
import dayjs from 'dayjs'
import { colors, fontSize } from '../../../foundation'
import { type DateRange } from '../DateRangePicker'
import { type DateRangePickerPresetConfig } from '../utils/DateRangePickerPresets.utils'

const DateRangePickerButtonCompactHeight = 28
const DateRangePickerButtonHeight = 38

export interface DateRangePickerControlProps {
  toggleDisplay: () => void
  displayOpen: boolean
  dates: DateRange
  selectedPresetConfig: DateRangePickerPresetConfig | undefined
  showAdditionalData?: boolean
  compact?: boolean
  className?: string
}

const formatDisplayDate = (date: Date | null) => (date ? dayjs(date).format('MMM DD, YYYY') : '')

export const DateRangePickerControl: FunctionComponent<DateRangePickerControlProps> = ({
  toggleDisplay,
  dates,
  displayOpen,
  selectedPresetConfig,
  showAdditionalData,
  className,
  compact = true,
}) => (
  <button
    css={{
      height: compact ? DateRangePickerButtonCompactHeight : DateRangePickerButtonHeight,
      width: showAdditionalData ? '40%' : ' 100%',
      padding: '4px 8px',
      borderRadius: compact ? '6px' : '8px',
      border: `1px solid ${colors.GRAYSCALE.X30}`,
      fontWeight: compact ? 'bold' : 'normal',
      fontSize: compact ? fontSize.X12 : fontSize.X15,
      verticalAlign: 'middle',
      display: 'flex',
      alignItems: 'center',
      paddingRight: '24px',
      backgroundColor: 'white',
      position: 'relative',
    }}
    className={className}
    onClick={toggleDisplay}
    data-testid="date-range-picker-control"
  >
    <DateIcon size={16} css={{ display: 'block', marginRight: 6 }} />
    <div>
      {selectedPresetConfig?.label}{' '}
      {`(${formatDisplayDate(dates.start)} - ${formatDisplayDate(dates.end)})`}
    </div>
    <div css={{ height: '100%', display: 'flex', alignItems: 'center' }}>
      <ChevronDownIcon
        css={{
          display: 'block',
          position: 'absolute',
          right: '8px',
          transform: displayOpen ? 'rotate(180deg)' : '',
        }}
      />
    </div>
  </button>
)
